import React from 'react'
import ReactDOM from 'react-dom'
import { t } from '../../helpers/translate'

class StaticTextComponent extends React.Component {

  render() {
    return <div className="form-group" id={this.props.id}>
      {t(this.props.value)}
    </div>
  }
}

export default StaticTextComponent;



// WEBPACK FOOTER //
// ./src/components/common/StaticTextComponent.js